/**
 * API base URL for the backend (optimus.Ink.backend).
 * Set VITE_API_URL in .env when the backend runs on a different host/port.
 */
export const getApiBaseUrl = () =>
    import.meta.env.VITE_API_URL || 'https://sandbox.optimus.ink';

/**
 * Base headers for all API requests. Includes ngrok-skip-browser-warning so ngrok doesn't show the browser warning page.
 * @returns {Record<string, string>}
 */
export const getBaseHeaders = () => ({
    'Content-Type': 'application/json',
    // 'ngrok-skip-browser-warning': 'true',
});

const getNetworkErrorMsg = () =>
    'Unable to connect to server. Please ensure the backend is running at ' +
    getApiBaseUrl() +
    ' and try again.';

/**
 * POST /api/auth/login
 * @param {{ email: string, password: string }} body
 * @returns {Promise<{ ok: boolean, data?: { user, tokens }, error?: string }>}
 */
export async function loginApi(body) {
    try {
        const base = getApiBaseUrl();
        const res = await fetch(`${base}/api/auth/login`, {
            method: 'POST',
            headers: getBaseHeaders(),
            body: JSON.stringify(body),
        });
        const json = await res.json().catch(() => ({}));
        if (res.ok && json.success === true && json.data) {
            return { ok: true, data: json.data };
        }
        const message =
            json?.error?.message || (res.ok ? 'Invalid response' : `Request failed (${res.status})`);
        return { ok: false, error: message, details: json?.error?.details };
    } catch (err) {
        if (err instanceof TypeError && err.message === 'Failed to fetch') {
            return { ok: false, error: getNetworkErrorMsg() };
        }
        return { ok: false, error: err?.message || 'Network error' };
    }
}

/**
 * POST /api/auth/register
 * @param {{ profileSlug: string, email: string, password: string }} body
 * @returns {Promise<{ ok: boolean, data?: { user, tokens }, error?: string }>}
 */
export async function registerApi(body) {
    try {
        const base = getApiBaseUrl();
        const res = await fetch(`${base}/api/auth/register`, {
            method: 'POST',
            headers: getBaseHeaders(),
            body: JSON.stringify(body),
        });
        const json = await res.json().catch(() => ({}));
        if (res.ok && json.success === true && json.data) {
            return { ok: true, data: json.data };
        }
        const message =
            json?.error?.message || (res.ok ? 'Invalid response' : `Request failed (${res.status})`);
        return { ok: false, error: message, details: json?.error?.details };
    } catch (err) {
        if (err instanceof TypeError && err.message === 'Failed to fetch') {
            return { ok: false, error: getNetworkErrorMsg() };
        }
        return { ok: false, error: err?.message || 'Network error' };
    }
}
